import { zodResolver } from '@hookform/resolvers/zod'
import {
  SaveRecipientFieldsRequestBody,
  buildSaveRecipientFieldsSchema,
  filterBindingFields,
} from 'bff'
import { useEffect, useMemo } from 'react'
import { useForm, useFormContext } from 'react-hook-form'
import { Form } from 'ui'
import { usePDFStore } from '../../../stores/pdf.store'
import { useSigning } from '../Context'
import { buildSigningFieldPath } from './Fields'

type FormData = SaveRecipientFieldsRequestBody

export const useSigningForm = () => {
  const form = useFormContext<FormData>()

  const fields = usePDFStore((state) => state.fields)

  const filteredFields = useMemo(
    () =>
      fields.filter((field) => {
        if (
          field.type === 'signature_date' &&
          !field.signature_field_id_to_record_date
        )
          return false

        if (field.signature_field_id_to_record_date) {
          console.log(
            'signature value!',
            form.getValues(buildSigningFieldPath(field))
          )
        }

        if (
          field.signature_field_id_to_record_date &&
          !form.getValues(buildSigningFieldPath(field))
        )
          return false

        return true
      }),
    [form.watch('fields')]
  )

  const signing = useSigning()

  return {
    ...form,
    filteredFields,
  }
}

export const SigningFormProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const fields = usePDFStore((state) => state.fields)

  const schema = useMemo(
    () => buildSaveRecipientFieldsSchema(filterBindingFields(fields)),
    []
  )

  const signing = useSigning()

  const defaultValues = useMemo(
    () =>
      signing.recipient.responses.reduce(
        (acc, curr) => {
          return {
            fields: {
              ...acc.fields,
              [curr.field_id]: curr.value,
            },
          }
        },
        {
          fields: {},
        } as FormData
      ),
    []
  )

  const form = useForm<FormData>({
    resolver: zodResolver(schema),
    reValidateMode: 'onChange',
    mode: 'onChange',
    defaultValues,
  })

  useEffect(() => {
    const errorFieldIds = Object.keys(form.formState.errors.fields || {})

    if (errorFieldIds.length > 0) {
      const [firstErrorFieldId] = errorFieldIds

      const fieldNode = document.getElementById(firstErrorFieldId)

      console.log('going to focus error', firstErrorFieldId)

      if (fieldNode) {
        fieldNode.scrollIntoView({
          block: 'center',
        })

        if (fieldNode.focus) {
          fieldNode.focus()
        }
      }
    }
  }, [form.formState.errors])

  return <Form {...form}>{children}</Form>
}
